import React from "react";
import { motion } from "framer-motion";

const FadeIn = ({
  children,
  className = "",
  delay = 0,
  duration = 0.5,
  y = 28,
  once = true,
}) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export default FadeIn;
